import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  constructor(private http: HttpClient) {}

  getFirstItem(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/review/first`,
    );
  }

  getReview(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/review/${id}`,
    );
  }

  saveAlternative(alternative: any): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/analytica/review`,
      alternative,
    );
  }

  saveSkip(ItemNumber: any): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/analytica/review?type=skip`,
      { master_id: ItemNumber },
    );
  }

  clearFormulary(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/review/cleanup`,
    );
  }

  outOf(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/review/out_of`,
    );
  }

  saveComment(id, comment): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/analytica/review/comment`,
      { id, comment },
    );
  }

  getReviewed(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/reviewed`,
    );
  }

  deleteReviewed(id): Observable<any> {
    return this.http.delete<any>(
      `${environment.api_url_v1}/services/analytica/reviewed/${id}`,
    );
  }

  getMultipliers(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/multiplier`,
    );
  }

  getMultiplier(id): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/multiplier/${id}`,
    );
  }

  saveMultiplier(mult: any): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/analytica/multiplier`,
      mult,
    );
  }

  deleteMultiplier(id): Observable<any> {
    return this.http.delete<any>(
      `${environment.api_url_v1}/services/analytica/multiplier/${id}`,
    );
  }

  getCDM(id): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/cdm?id=${id}`,
    );
  }

  getAllCDM(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/cdm`,
    );
  }

  saveCDM(cdm): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/analytica/cdm`,
      cdm,
    );
  }

  deleteCDM(id): Observable<any> {
    return this.http.delete<any>(
      `${environment.api_url_v1}/services/analytica/cdm/${id}`,
    );
  }
}
